/**
 * Main
 *
 * Main app for page interactivity
 *
 */

// Slider
import 'slick-carousel';
import initSlider from './imports/slider';

import customSvg from './imports/customsvg';

import './imports/init';

/* Custom JS */

/* Sections */
import './sections/section-float_box';

/* Block */
import './sections/services';
import './sections/career';
import './sections/nouvelles';
import './sections/social';

/* Menu */
import './imports/menu';

/* Map */
import './imports/map';

customSvg.library = {
};


function init() {
    // customSvg.init();
    initSlider();
}

$(init());
